module.exports = __webpack_public_path__ + "23fa77bb7131f65ecde93b20f55031c2.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1085
// module chunks = 0